import React, { useEffect, useRef } from 'react';
import {
  Grid,
  Typography,
} from '@mui/material';

const GlobalTextField = ({
  style,
  formikProps,
  text,
  name,
  placeholder,
  isRequired,
  multipleLines,
  maxLength,
}) => {
  // Référence à la zone de texte
  const textAreaRef = useRef(null);

  // Ajuster la hauteur de la zone de texte lors du premier rendu et au changement de contenu
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [formikProps.values[name]]); // Déclenche au changement du contenu

  return (
    <div className="pt-2">
      <label className="block text-sm font-medium text-gray-700">{text}</label>

      <textarea
        ref={textAreaRef}
        value={formikProps.values[name]}
        onBlur={formikProps.handleBlur}
        onChange={formikProps.handleChange}
        name={name}
        placeholder={placeholder}
        required={isRequired}
        maxLength={maxLength}
        rows={multipleLines ? 2 : 1}
        className="w-full p-2 border border-black/20 rounded-sm focus:outline-none resize-none overflow-hidden"
        style={{ ...style }}
        onInput={(e) => {
          e.target.style.height = 'auto'; // Pour remettre à zéro la hauteur
          e.target.style.height = e.target.scrollHeight + 'px'; // Redimensionner en fonction du contenu
        }}
      />

      <div className="flex justify-between text-xs text-gray-500 mt-1">
        {maxLength && (
          <Grid item>
            <Typography
              variant='caption'
              display='block'
              sx={{ textAlign: 'right' }}
            >
              {formikProps.values[name].length} / {maxLength}
            </Typography>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default GlobalTextField;